import { defineMessages } from "react-intl";
export default defineMessages({
  day: {
    "id": "calendar.day",
    "defaultMessage": "Day"
  },
  last24Hours: {
    "id": "calendar.last24Hours",
    "defaultMessage": "Last 24 hours"
  },
  week: {
    "id": "calendar.week",
    "defaultMessage": "Week"
  },
  last7Days: {
    "id": "calendar.last7Days",
    "defaultMessage": "Last 7 days"
  },
  month: {
    "id": "calendar.month",
    "defaultMessage": "Month"
  },
  last30Days: {
    "id": "calendar.last30Days",
    "defaultMessage": "Last 30 days"
  },
  months: {
    "id": "calendar.months",
    "defaultMessage": "months"
  },
  year: {
    "id": "calendar.year",
    "defaultMessage": "Year"
  },
  max: {
    "id": "calendar.max",
    "defaultMessage": "Max"
  },
  thirtyMinutes: {
    "id": "calendar.thirtyMinutes",
    "defaultMessage": "30-min"
  },
  oneHour: {
    "id": "calendar.oneHour",
    "defaultMessage": "1-hour"
  },
  threeHours: {
    "id": "calendar.threeHours",
    "defaultMessage": "3-hour"
  },
  sixHours: {
    "id": "calendar.sixHours",
    "defaultMessage": "6-hour"
  },
  oneDay: {
    "id": "calendar.oneDay",
    "defaultMessage": "1-day"
  },
  oneWeek: {
    "id": "calendar.oneWeek",
    "defaultMessage": "1-week"
  },
  oneMonth: {
    "id": "calendar.oneMonth",
    "defaultMessage": "1-month"
  },
  selectTimescale: {
    "id": "calendar.selectTimescale",
    "defaultMessage": "Select a time scale"
  },
  selectGranularity: {
    "id": "calendar.selectGranularity",
    "defaultMessage": "Select a granularity"
  },
  previousDay: {
    "id": "calendar.previousDay",
    "defaultMessage": "Previous day"
  },
  sameDayLastYear: {
    "id": "calendar.sameDayLastYear",
    "defaultMessage": "Same day last year"
  },
  previous24Hours: {
    "id": "calendar.previous24Hours",
    "defaultMessage": "Previous 24 hours"
  },
  previousWeek: {
    "id": "calendar.previousWeek",
    "defaultMessage": "Previous week"
  },
  previous7Days: {
    "id": "calendar.previous7Days",
    "defaultMessage": "Previous 7 days"
  },
  previous30Days: {
    "id": "calendar.previous30Days",
    "defaultMessage": "Previous 30 days"
  },
  previousMonth: {
    "id": "calendar.previousMonth",
    "defaultMessage": "Previous month"
  },
  sameMonthLastYear: {
    "id": "calendar.sameMonthLastYear",
    "defaultMessage": "Same month last year"
  },
  previousYear: {
    "id": "calendar.previousYear",
    "defaultMessage": "Previous year"
  },
  hours: {
    "id": "calendar.hours",
    "defaultMessage": "Hours"
  },
  hoursShort: {
    "id": "calendar.hoursShort",
    "defaultMessage": "hrs"
  },
  use24HourFormat: {
    "id": "calendar.use24HourFormat",
    "defaultMessage": "Use 24-hour format"
  },
  dateFormat: {
    "id": "calendar.dateFormat",
    "defaultMessage": "Date format"
  },
  yesterday: {
    "id": "calendar.yesterday",
    "defaultMessage": "Yesterday"
  }
});